<template>
    <div>
        <div v-if="viewType === 'grid'" class="card">
            <div class="card-header">
                <div class="info">
                    <div class="name-row">
                        <common-rating-avatar
                            :rating="physician.professionalRating"
                            :user="physician"
                            :size="avatarSize"
                            :isUserProfileLinkEnabled="isUserProfileLinkEnabled"
                        ></common-rating-avatar>

                        <div class="tags">
                            <div class="main-name-row">
                                <h3>
                                    <common-network-user-name :user="physician"></common-network-user-name>
                                </h3>
                                <span v-if="physician?.isNpiVerified" class="verified">
                                    <common-icon name="verify" size="small" class="verify-icon"></common-icon>
                                    {{ $t('pages.network.connections.network_profile_detail.verify') }}
                                </span>
                                <span v-if="physician?.rating" class="rating">
                                    <common-icon name="star" size="small"></common-icon>
                                    <span class="rating-count">{{ physician?.rating || 0 }}</span>
                                    <span class="check"><common-icon name="check" size="small"></common-icon></span>
                                </span>
                            </div>

                            <p class="clinic">
                                {{
                                    showMasterUserAuthorities
                                        ? $get(physician, 'userRole.name')
                                        : $get(physician, 'practice.name')
                                }}
                            </p>
                            <span class="tag">
                                <common-icon name="blood" size="small" class="blood-icon"></common-icon>
                                {{ $t('pages.network.connections.network_profile_detail.board') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p class="speciality">
                    {{ physician?.specialities[0].speciality.name }}
                </p>

                <p class="location">
                    <common-icon name="location" size="small"></common-icon>
                    {{ physician?.practice?.city }}, {{ physician?.practice?.state }}
                </p>

                <p v-if="isInMyNetwork" class="connections">
                    {{ physician?.connectionCount }}
                    {{ $t('pages.network.connections.network_profile_detail.connection') }}
                </p>
                <p v-else class="connections">
                    {{ $t('elements.network.network_inclusion_status.buttons.add_to_my_network') }}
                </p>
            </div>
            <div class="card-footer">
                <common-button
                    icon="refer"
                    class="refer-btn"
                    :label="$t('pages.network.connections.buttons.refer')"
                    size="large"
                    type="primary"
                    @click="itemClicked()"
                ></common-button>
                <div class="actions">
                    <common-button
                        v-if="physician?.email"
                        icon="chat"
                        class="icon-btn"
                        size="small"
                        type="info"
                        @click="toggleshowEmailForm()"
                    ></common-button>
                    <common-button
                        v-if="physician?.mobilePhone"
                        icon="phones"
                        class="icon-btn"
                        size="small"
                        type="info"
                        @click="makeCall"
                    ></common-button>
                </div>
            </div>
        </div>

        <div v-else class="card-layout">
            <div class="card-header">
                <div class="info">
                    <div class="name-row">
                        <common-rating-avatar
                            :rating="physician.professionalRating"
                            :user="physician"
                            :size="avatarSize"
                            :isUserProfileLinkEnabled="isUserProfileLinkEnabled"
                        ></common-rating-avatar>

                        <div class="tags">
                            <div class="name-row">
                                <h3>
                                    <common-network-user-name :user="physician"></common-network-user-name>
                                </h3>
                                <span v-if="physician?.isNpiVerified" class="verified">
                                    <common-icon name="verify" size="small" class="verify-icon"></common-icon>
                                    {{ $t('pages.network.connections.network_profile_detail.verify') }}
                                </span>
                                <span class="tag">
                                    <common-icon name="blood" size="small" class="blood-icon"></common-icon>
                                    {{ $t('pages.network.connections.network_profile_detail.board') }}
                                </span>
                            </div>
                            <div class="detail">
                                <p class="clinic">
                                    {{
                                        showMasterUserAuthorities
                                            ? $get(physician, 'userRole.name')
                                            : $get(physician, 'practice.name')
                                    }}
                                </p>
                                <p class="speciality">
                                    {{ physician?.specialities[0].speciality.name }}
                                </p>

                                <div class="name-row">
                                    <p class="location">
                                        <common-icon name="location" size="small"></common-icon>
                                        {{ physician?.practice?.city }}, {{ physician?.practice?.state }}
                                        <span>•</span>
                                    </p>
                                    <p v-if="isInMyNetwork" class="connections">
                                        {{ physician?.connectionCount }}
                                        {{ $t('pages.network.connections.network_profile_detail.connection') }}
                                    </p>
                                    <p v-else class="connections">
                                        {{ $t('elements.network.network_inclusion_status.buttons.add_to_my_network') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <span class="rating">
                            <div v-if="physician?.rating">
                                <common-icon name="star" size="small"></common-icon>
                                <span class="rating-count">
                                    {{ physician?.rating || 0 }}
                                </span>
                                <span class="check"><common-icon name="check" size="small"></common-icon></span>
                            </div>
                        </span>
                        <div class="actions">
                            <common-button
                                icon="refer"
                                class="refer-btn"
                                :label="$t('pages.network.connections.buttons.refer')"
                                size="small"
                                type="primary"
                                @click="itemClicked()"
                            ></common-button>
                            <common-button
                                v-if="physician?.email"
                                icon="chat"
                                class="icon-btn"
                                size="small"
                                type="info"
                                @click="toggleshowEmailForm()"
                            ></common-button>
                            <common-button
                                v-if="physician?.mobilePhone"
                                icon="phones"
                                class="icon-btn"
                                size="small"
                                type="info"
                                @click="makeCall"
                            ></common-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <direct-referral
            v-if="isDirectReferralModalOpen"
            :activePracticeType="practiceType"
            :user="physician"
            @location-selected="toggleModal"
            @close="toggleModal"
        ></direct-referral>
        <common-modal v-if="showEmailForm" @close="closeSendNetworkMessageModal()">
            <email-form
                headerText="Send email"
                :defaultUser="physician"
                :showBccWarning="true"
                :showOpenSelectMemberModalButton="true"
                @email-data="sendEmail"
                @close="toggleshowEmailForm()"
            ></email-form>
        </common-modal>
    </div>
</template>

<script>
    import EmailForm from '../../forms/connections/EmailForm.vue'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            EmailForm,
            DirectReferral,
        },

        props: {
            physician: { type: Object, required: true },
            size: { type: String, default: 'large' },
            showMasterUserAuthorities: { type: Boolean, default: false },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
            viewType: { type: String, required: true },
        },

        data() {
            return {
                showEmailForm: false,
                isDirectReferralModalOpen: false,
                practiceType: PracticeTypeEnum.PHYSICIAN,
            }
        },
        computed: {
            avatarSize() {
                switch (this.size) {
                    case 'medium':
                        return 'user-context'
                    default:
                        return 'member-switch'
                }
            },
            isInMyNetwork() {
                return this.physician.isInMyNetwork !== undefined ? this.physician.isInMyNetwork : true
            },
        },
        methods: {
            sendEmail(event) {
                let bcc = []
                event.to.forEach((user) => {
                    bcc.push(user)
                })
                bcc.splice(event.to, 1)
                window.open(
                    `mailto:${event.to[0]}?bcc=${bcc || ''}&cc=${event.cc || ''}&subject=${event.subject}&body=${
                        event.message
                    }&from=${event.from}`,
                    '_blank',
                )
            },
            toggleshowEmailForm() {
                this.showEmailForm = !this.showEmailForm
            },
            closeSendNetworkMessageModal() {
                this.showEmailForm = false
            },
            toggleModal() {
                this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
            },
            itemClicked() {
                this.toggleModal()
            },
            makeCall() {
                if (!this.physician?.mobilePhone) return
                window.location.href = `tel:${this.physician.mobilePhone}`
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/network/_network';
</style>
